import { render } from "./ModuleTestsSection.vue?vue&type=template&id=277041a5&scoped=true"
import script from "./ModuleTestsSection.vue?vue&type=script&lang=js"
export * from "./ModuleTestsSection.vue?vue&type=script&lang=js"

import "./ModuleTestsSection.vue?vue&type=style&index=0&id=277041a5&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-277041a5"]])

export default __exports__